export const FILTER_TYPE = {
  Prospect: "prospects",
  Customer: "customers",
  IBO: "ibos",
};
